import socketIO from "socket.io-client";

import { getBaseUrl } from "./Webiste/service/apiUrl";
const socket = socketIO.connect(getBaseUrl());
// const socket = socketIO.connect("https://sumairroudani.com/");

export default socket;
